<div class="row" [formGroup]="formulario">
  <div class="col-12 col-md-2">
    <mat-form-field class="full-width w-100" appearance="fill">
      <mat-label>CEP</mat-label>
      <input formControlName="cep" mask="00000-000" matInput (blur)="buscarDadosCep()" required>
    </mat-form-field>
  </div>
  <div class="col-12 col-md-2">
    <mat-form-field class="full-width w-100" appearance="fill">
      <mat-label>Estado</mat-label>
      <mat-select formControlName="estado" required>
        <mat-option *ngFor="let estado of estados" [value]="estado">{{ getSiglaEstado(estado) }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="col-12 col-md-4">
    <mat-form-field class="full-width w-100" appearance="fill">
      <mat-label>Endereço</mat-label>
      <input formControlName="address" matInput required>
    </mat-form-field>
  </div>
  <div class="col-12 col-md-2">
    <mat-form-field class="full-width w-100" appearance="fill">
      <mat-label>Quadra</mat-label>
      <input formControlName="block" matInput required>
    </mat-form-field>
  </div>
  <div class="col-12 col-md-2">
    <mat-form-field class="full-width w-100" appearance="fill">
      <mat-label>Lote</mat-label>
      <input formControlName="batch" matInput required>
    </mat-form-field>
  </div>
  <div class="col-12 col-md-4">
    <mat-form-field class="full-width w-100" appearance="fill">
      <mat-label>Complemento</mat-label>
      <input formControlName="complement" matInput>
    </mat-form-field>
  </div>
  <div class="col-12 col-md-4">
    <mat-form-field class="full-width w-100" appearance="fill">
      <mat-label>Bairro</mat-label>
      <input formControlName="bairro" matInput required>
    </mat-form-field>
  </div>
  <div class="col-12 col-md-4">
    <mat-form-field class="full-width w-100" appearance="fill">
      <mat-label>Cidade</mat-label>
      <input formControlName="cidade" matInput>
    </mat-form-field>
  </div>
  <div class="col-12" *ngIf="showObservation">
    <mat-form-field class="full-width w-100" appearance="fill">
      <mat-label>Observação</mat-label>
      <textarea formControlName="observation" matInput></textarea>
    </mat-form-field>
  </div>
</div>
